// src/permissions/index.ts
function can(permissions, ...keys) {
  if (!permissions || keys.length === 0) return false;
  return keys.every((key) => permissions.includes(key));
}
function canOn(resourcePermissions, relation) {
  return resourcePermissions?.includes(relation) ?? false;
}
function hasEntitlement(entitlements, key) {
  if (!entitlements || !Object.hasOwn(entitlements, key)) return false;
  const value = entitlements[key];
  if (typeof value === "number") return value > 0;
  return value === true || value === "basic" || value === null;
}
function entitlementLimit(entitlements, key) {
  const value = entitlements?.[key];
  return typeof value === "number" ? value : null;
}

// src/session/session-store.ts
import { MeResponseSchema } from "@batiflow/contracts";
import { createStore } from "zustand/vanilla";
var ACTIVE_ORG_STORAGE_KEY = "bf.activeOrgId";
function pickActiveOrg(me, preferred) {
  const ids = me.memberships.map((m) => m.organizationId);
  if (preferred && ids.includes(preferred)) return preferred;
  return ids[0] ?? null;
}
function createSessionStore({ loadMe, storage }) {
  return createStore()((set, get) => ({
    status: "idle",
    me: null,
    activeOrgId: null,
    mfaRequired: false,
    async bootstrap() {
      set({ status: "loading" });
      try {
        const raw = await loadMe();
        if (raw === null) {
          set({ status: "anonymous", me: null, activeOrgId: null, mfaRequired: false });
          return;
        }
        const me = MeResponseSchema.parse(raw);
        const activeOrgId = pickActiveOrg(me, storage.getItem(ACTIVE_ORG_STORAGE_KEY));
        set({ status: "authenticated", me, activeOrgId, mfaRequired: me.session.mfaRequired });
      } catch {
        set({ status: "error" });
      }
    },
    switchOrganization(orgId) {
      const me = get().me;
      if (!me?.memberships.some((m) => m.organizationId === orgId)) return false;
      set({ activeOrgId: orgId });
      storage.setItem(ACTIVE_ORG_STORAGE_KEY, orgId);
      return true;
    },
    setMfaRequired(required) {
      set({ mfaRequired: required });
    },
    clear() {
      set({ status: "anonymous", me: null, activeOrgId: null, mfaRequired: false });
    }
  }));
}
var NO_PERMISSIONS = Object.freeze([]);
var NO_ENTITLEMENTS = Object.freeze({});
var selectActiveMembership = (s) => s.me?.memberships.find((m) => m.organizationId === s.activeOrgId) ?? null;
var selectPermissions = (s) => selectActiveMembership(s)?.permissions ?? NO_PERMISSIONS;
var selectEntitlements = (s) => selectActiveMembership(s)?.entitlements ?? NO_ENTITLEMENTS;
var selectCsrfToken = (s) => s.me?.csrfToken ?? null;
var selectSessionRemainingMs = (s, now) => s.me ? Date.parse(s.me.session.expiresAt) - now : null;

export {
  can,
  canOn,
  hasEntitlement,
  entitlementLimit,
  ACTIVE_ORG_STORAGE_KEY,
  createSessionStore,
  selectActiveMembership,
  selectPermissions,
  selectEntitlements,
  selectCsrfToken,
  selectSessionRemainingMs
};
//# sourceMappingURL=chunk-YXNSSCIE.js.map